<sub-navbar></sub-navbar>
<div class="step-container">
  <form
    [formGroup]="stepForm"
    [ngClass]="{ submitted: formSubmitAttempt }"
    (ngSubmit)="onSubmit()"
    #questionForm="ngForm"
  >
    <input formControlName="questionId" type="hidden" />
    <div class="step-content step{{ currentStep }} flex flex-col">
      <div class="eval-step-title">{{ title }}</div>
      <div class="eval-question">
        {{ question }}
        <tooltip-popover #tooltip position="bottom">
          <mat-icon-with-hover
            #tooltipIcon
            iconName="tooltip_default"
            iconNameActive="tooltip_active"
            iconNameHover="tooltip_hover"
          ></mat-icon-with-hover>
          <ng-template #tooltipPopoverContent="cdkPortal" cdkPortal let-tooltipPopover>
            <mat-icon (click)="tooltip.closePopover()" class="close-icon" svgIcon="close_tiny"></mat-icon>
            <div class="multiline-content">
              <strong>Did the consultant present:</strong>
              <ul>
                @for (skill of desiredSkills; track skill) {
                  <li>{{ skill }}?</li>
                }
              </ul>
            </div>
          </ng-template>
        </tooltip-popover>
      </div>
      <validation-messages
        [field]="stepForm.get('evalAnswer')"
        [messages]="['required']"
        [texts]="{ required: 'Please provide the required field(s) to continue to the next step.' }"
        class="error"
      ></validation-messages>
      <div class="eval-answers flex flex-col">
        <hr />
        <mat-radio-group
          class="flex flex-col sm:flex-row flex-between-stretch"
          color="accent"
          formControlName="evalAnswer"
        >
          <mat-radio-button [value]="1" id="eval-answer1">Strongly disagree</mat-radio-button>
          <mat-radio-button [value]="2" id="eval-answer2">Disagree</mat-radio-button>
          <mat-radio-button [value]="3" id="eval-answer3">Neutral</mat-radio-button>
          <mat-radio-button [value]="4" id="eval-answer4">Agree</mat-radio-button>
          <mat-radio-button [value]="5" id="eval-answer5">Strongly agree</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="eval-answer-comment">
        <mat-form-field appearance="outline" class="textarea-input w-full" floatLabel="always">
          <mat-label>Leave feedback (optional)</mat-label>
          <textarea
            [maxlength]="feedbackMaxLength"
            formControlName="feedback"
            id="eval-answer-feedback"
            matInput
            placeholder="Please comment on any specific observations that have been important for your score. (Max. {{
              feedbackMaxLength
            }} chars)"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
